import { isInteger } from '@superbet-group/web.lib.utilities';

const numericBeginning = /^\d+/;

// appends unicode /3 to leading digits in css selectors for id
export default function sanitizeQuerySelector(selector: string) {
    if (selector[0] === '#' && isInteger(selector[1])) {
        let _selector = selector.slice(1);
        const numbers = _selector.match(numericBeginning)![0];
        _selector = _selector.slice(numbers.length);
        const escapedNumbers = numbers.split('').reduce((acc, curr) => `${acc}\\3${curr}`, '');
        // https://mathiasbynens.be/notes/css-escapes
        return `#${escapedNumbers}${_selector}`;
    }
    return selector;
}
